// Author Liang Gang Qiang
// Date 2024-05-30 13:46:54

import * as model from "@/model/sithMes/prd/SithMesPrdProjectKamModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdProjectKam(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'allInfoViewENVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'listViewENVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'listViewVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'allInfoViewVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'exportVoVo'
    })
    .buildStore()
